'use client';

import Image from 'next/image';

import { Button } from '@/components/Button';
import { useZmyleCookieStore } from '@/hooks/useZmyleCookieStore';
import { CookieWidget } from '@/services/cookieWidget';

type EnableMaptilerCookieProps = {
  content: OutletsMapContent;
};

export function EnableMaptilerCookie({ content }: EnableMaptilerCookieProps) {
  const { enableCookieMessage, mapPlaceholderUrl } = content;

  const refresh = useZmyleCookieStore(state => state.refresh);

  function onOpenCookiePermission() {
    CookieWidget.getInstance().open({
      section: 'media',
      onSubmit() {
        refresh();
      },
    });
  }

  return (
    <Button
      variant="ghost"
      className="relative flex w-full cursor-pointer items-center justify-center overflow-hidden"
      onClick={onOpenCookiePermission}
    >
      <Image
        src={mapPlaceholderUrl}
        alt="Map Placeholder"
        loading="lazy"
        fill
        className="size-full object-cover"
      />

      <p className="absolute top-1/2 right-1/2 w-full translate-x-1/2 -translate-y-1/2 px-2 text-center lg:text-xl">
        {enableCookieMessage}
      </p>
    </Button>
  );
}
